module.exports = __webpack_public_path__ + "img/ZJ5241.8bba5d67.png";